import React, { useEffect, useState } from "react";
import SectionTitle from "../../Components/SectionTitle";
import { Link } from "react-router-dom";
import { Button, Popover, Table } from "antd";
import { PiPlus } from "react-icons/pi";
import AddNewCategory from "./Components/AddNewCategory";
import { CategoryTableColumns, CategoryTableData } from "./types";
import DashModal from "../../Components/DashModal";
import { getCategories } from "./action";
import EditSEO from "./Components/EditSEO";
import EditCategory from "./Components/EditTitle";

type Props = {
  editSeo?: boolean;
  editTitle?: boolean;
};

const Categories = (props: Props) => {
  const [data, setData] = useState<CategoryTableData[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const columns = CategoryTableColumns();
  const fetchData = async () => {
    setLoading(true);
    const result = await getCategories();
    if (result) {
      const mappedResult = result.map((item) => ({
        ...item,
        title: item.MainInfo.Title,
        keywords: item.Seo.Keywords,
        articlesCount: item.Info.ArticleCount,
      }));
      setData(mappedResult);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="space-y-5">
      <SectionTitle title="Categories" />
      <div className="flex justify-between items-center">
        <Popover
          content={<AddNewCategory onCategoryAdded={fetchData} />}
          trigger="click"
          open={open}
          onOpenChange={handleOpenChange}
        >
          <Button type="primary" icon={<PiPlus />}>
            Add New Category
          </Button>
        </Popover>
      </div>{" "}
      <Table<CategoryTableData>
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="id"
        pagination={{
          position: ["bottomRight"],
          pageSize: 10,
          showSizeChanger: true,
          showQuickJumper: true,
        }}
        bordered
        size="large"
      />
      {props.editSeo && (
        <DashModal
          title="Edit Category Seo"
          width={800}
          cancleLink="/categories"
        >
          <EditSEO onSeoEdit={fetchData} />
        </DashModal>
      )}
      {props.editTitle && (
        <DashModal
          title="Edit Category Title"
          width={500}
          cancleLink="/categories"
        >
          <EditCategory onCategoryEdited={fetchData} />
        </DashModal>
      )}
    </div>
  );
};

export default Categories;
